@if (loadingTicket) {
  <div class="loading-overlay d-flex align-items-center justify-content-center">
    <div class="bg"></div>
    <div class="box p-4">
      <i class="fa fa-spin fa-spinner"></i> <br />
      <b><i>carregando chamado</i></b>
    </div>
  </div>
}
<div class="edit-ticket-container page-wrapper">
  <div class="page-header bg-primary-600">
    <ticket-show-header
      class="w-100"
      [entity]="entity"
      [isSaving]="saving"
      [showSaveButton]="true"
      (save)="ticketShowBodyComponent?.save()"></ticket-show-header>
  </div>

  <div class="page-content">
    <ticket-show-body
      [entity]="entity"
      [hasConfirmation]="true"
      [loading]="loadingTicket"
      (saving)="saving = $event"
      [isSaving]="saving"
      [showSaveButton]="false"
      [showTabsBodies]="true"></ticket-show-body>
  </div>
</div>
